// "View as" lets an allowed user preview the site as another role.
// Kelly can use it through her Admin role. Add other allowed login emails here,
// in lowercase. This is a preview only: it changes what the screens show,
// not what the database allows.
export const VIEW_AS_EMAILS = ['solutionsbytina7@gmail.com'];

export const VIEW_AS_ROLES = ['Agent', 'TC', 'Marketing Manager', 'Buyer', 'Closing Concierge', 'Local Assistant'];

// Spreading a Firebase User drops its prototype methods (getIdToken etc.), which broke
// API calls in View-as mode. Keep the real signed-in user's token methods: the server
// authorizes the real login (e.g. Kelly as Admin), never the previewed person.
export function withRealTokens(realUser, overrides) {
  return {
    ...realUser,
    ...overrides,
    getIdToken: (...a) => realUser.getIdToken(...a),
    getIdTokenResult: (...a) => realUser.getIdTokenResult(...a),
    reload: (...a) => realUser.reload(...a),
  };
}
